// src/extenders/product-card.js
var ProductCard = class extends HTMLElement {
  constructor() {
    super();
    this.swiperGallery = this.querySelector("swiper-carousel");
    this.paginationElem = this.querySelector(".swiper-pagination-wrapper");
  }
  connectedCallback() {
    if (!this.swiperGallery) {
      return;
    }
    if (typeof this.swiperGallery.swiperOptions === "undefined") {
      this.swiperGallery.addEventListener("swiper:connected", this._initSwiper.bind(this));
    } else {
      this._initSwiper();
    }
  }
  _initSwiper() {
    if (!this.paginationElem) {
      this.swiperGallery.instantiate();
      return;
    }
    const swiperOptions = this.swiperGallery.swiperOptions;
    swiperOptions.pagination = swiperOptions.pagination || { clickable: true };
    swiperOptions.pagination = Object.assign(swiperOptions.pagination, {
      el: this.paginationElem
    });
    this.swiperGallery.instantiate();
  }
};
if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
